<script lang="ts">
  import Link from "$components/link.svelte";
  import { toBreadCrumb } from "$lib/utils/ldjson";

  export let paths: { url?: string; name: string }[];
  export let macro = false;
  export let textCenter = false;

  const liProps = {
    itemprop: "itemListElement",
    itemtype: "https://schema.org/ListItem",
  };
</script>

<svelte:head>
  {@html toBreadCrumb(paths)}
</svelte:head>

<div class="breadcrumb" class:custom-top-grid={$$slots.logo}>
  {#if $$slots.logo}
    <slot name="logo" />
  {/if}
  <div class="content" class:text-center={textCenter}>
    <slot />
    <ol class="sf-500" itemscope {...macro && { itemtype: "https://schema.org/BreadcrumbList" }}>
      {#each paths as path, i}
        {@const finalIndex = paths.length - 1 === i}
        <li class={`pf-300   ${paths.length - 1 === i ? "active" : ""}`} itemscope {...macro && liProps}>
          {#if path.url}
            <Link {macro} href={path.url}>
              <span class="sf-300" itemprop="name">{path.name}</span>
            </Link>
          {:else}
            <span class="sf-300" itemprop="name">{path.name}</span>
          {/if}
          {#if macro}
            <meta itemprop="position" content={(i + 1).toString()} />
          {/if}
        </li>
        {#if !finalIndex}
          <li class="arrow"><i /></li>
        {/if}
      {/each}
    </ol>
  </div>
</div>

<style lang="scss">
  @use "@styles/breakpoint-mixins" as *;

  .breadcrumb {
    width: 100%;
  }

  .content {
    text-align: center;
    @include tablet {
      text-align: unset;
    }

    &.text-center {
      text-align: center;
    }
  }

  .custom-top-grid {
    padding: 0;
    margin: 0;
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 1.25em;
  }

  ol {
    margin: 0;
    padding: 0;
    /* padding-bottom: 1.17em; */
    font-size: 13px;
    line-height: 30px; /* 230.769% */
    text-align: center;
    @include tablet {
      text-align: unset;
    }

    li {
      display: inline;
      list-style: none;
      margin: 0;
      user-select: none;
      position: relative;
      cursor: pointer;
      text-transform: capitalize;
      padding: 0;
      margin-right: 0.3125em;

      span {
        line-height: 1.875em;
        margin: 0;
        position: relative;
        color: var(--tp-black2);
      }
      &.arrow {
        line-height: 0.75em;
        cursor: unset;
        padding-right: 0.75em;
        i {
          background: url("./arrow.svg") no-repeat center;
          position: absolute;
          top: 0.25em;
          width: 0.75em;
          height: 0.75em;
        }
      }
    }
  }
</style>
